import {useAuthUserStore} from "@/stores/auth";

/*
 * API V2 de gestión de cursos nativos (`/v2/lms/courses`, backend LMS-051).
 * Las respuestas son `CourseResource`, por lo que el curso viene en `response.data.data`.
 */
const apiClient = () => useAuthUserStore().getApiClient
const coursePath = (courseUuid) => '/v2/lms/courses/' + courseUuid

export default {
    store(academyUuid, course) {
        return apiClient().post('/v2/lms/courses', {
            academy_uuid: academyUuid,
            title: course.title,
        })
    },
    show(courseUuid) {
        return apiClient().get(coursePath(courseUuid))
    },
    /*
     * Ficha del curso (LMS-050, LMS-054). Si hay portada nueva se envía como
     * multipart con `_method=PUT`, porque PHP no lee ficheros en peticiones PUT.
     */
    update(courseUuid, course, cover = null) {
        const fields = {
            title: course.title,
            subtitle: course.subtitle,
            description: course.description,
            slug: course.slug,
        }

        if (!cover) {
            return apiClient().put(coursePath(courseUuid), fields)
        }

        const formData = new FormData()
        Object.entries(fields).forEach(([key, value]) => formData.append(key, value ?? ''))
        formData.append('cover', cover)
        formData.append('_method', 'PUT')

        return apiClient().post(coursePath(courseUuid), formData)
    },
    // Borrador, publicado o archivado (LMS-052).
    updateStatus(courseUuid, status) {
        return apiClient().put(coursePath(courseUuid) + '/status', {status})
    },
    // Copia completa en borrador con el sufijo «(copia)» (LMS-055).
    duplicate(courseUuid) {
        return apiClient().post(coursePath(courseUuid) + '/duplicate')
    },
    /*
     * Borrado con protección (LMS-056): responde 409 si hay matrículas activas, salvo
     * que se envíe `force` junto con el nombre del curso como confirmación.
     */
    destroy(courseUuid, confirmation = null) {
        const data = confirmation ? {force: true, confirmation} : {}
        return apiClient().delete(coursePath(courseUuid), {data})
    },
}
